// Section 8: Farmer. Plants in Spring (0.5 seed per plot), small early harvest in Summer
// (0.3x), main harvest in Autumn (4.0 food per plot), nothing in Winter. Plough 1.5x; 2% injury.
// Constants: config.jobs.farmer, config.seasons.crops, config.land.crops.
import type { Config } from '../../config';
import { evaluate, collect, mod } from '../../core/modifiers';
import { alwaysEligible, jobOutput, produced } from '../../core/content-helpers';
import { defineJob } from '../../core/registry';

export function farmer(config: Config) {
  const c = config.jobs.farmer;

  return defineJob({
    id: 'farmer',
    label: 'Farmer',
    section: 'S8',
    heavy: false,
    output: { kind: 'stock', resource: 'food' },
    baseYield: c.plotYield,
    toolFactor: c.toolFactor,
    toolWear: 0,
    risks: { injury: c.injury },
    riskIllness: null,
    requiresBuilding: 'field',
    minStrength: 0,
    modifierTargets: ['output'],
    modifierKeys: { output: ['farmer'] },
    modifiers: jobOutput('farmer', (ctx) => {
      const harvest = evaluate(1, collect(ctx, { kind: 'harvestYield' })).value;
      return harvest === 1 ? [] : [mod.mul('job:farmer', harvest, 'harvest conditions')];
    }),
    produce(ctx, worker, output) {
      const season = ctx.season.season;
      if (season === 'spring')
        return [{ kind: 'plant', personId: worker.id, plots: c.plotsPerFarmer }];
      const plots = ctx.state.plantedPlots[worker.id] ?? 0;
      return plots > 0 && output > 0 ? [produced('food', output * plots)] : [];
    },
    eligible: alwaysEligible,
  });
}
